










































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, State, Mutation, Getter} from 'vuex-class';
import BInput from 'buefy/src/components/input/Input.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BSelect from 'buefy/src/components/select/Select.vue';
import BDatepicker from 'buefy/src/components/datepicker/Datepicker.vue';
import {MAFUser} from '@/store/User/types';
import MAFDropdown from '@/components/common/MAFDropdown.vue';
import {Lookup} from '@/store/types'; // @ is an alias to /src
import * as luxon from 'luxon';
import Slider from '../common/Slider.vue';
import {OptionType} from '@/components/common/types';
import {DateTime} from 'luxon';

const namespace = 'userState';
@Component({
    components: {
        BDatepicker,
        BField,
        BButton,
        BInput,
        BSelect,
        Slider,
        MAFDropdown,
    },
})
export default class PersonalInfo extends Vue {
    @Prop(MAFUser) public readonly self!: MAFUser;
    @State('diagnosis', {namespace}) public diagnosis: Lookup | undefined;
    // @State('userType', {namespace}) public userType: string | undefined;
    @Getter('getUserType', {namespace})  public userTypes: string[] | undefined;

    @Action('updateSelfDoc', {namespace}) public updateSelfDoc: any;
    @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;
    @Action('sendEmailNotification', {namespace: 'friendState'}) public sendEmailNotification!: any;

    public BASE_URL: string;
    public update: MAFUser;
    public isLoading: boolean;
    public isVerifyLoading: boolean;
    public sliderOptions: OptionType[];
    public nameMessage: string;
    public genderMessage: string;
    public birthdateMessage: string;
    public zipCodeMessage: string;
    public codeMessage: string = '';
    public websiteMessage: string;
    public phoneMessage: string = '';
    public providerMessage: string = '';
    public userTypeMessage: string;
    public verificationSent: boolean;
    public generatedCode: number;
    public enteredCode: string = '';
    public cellProviderOptions: any[] = [
        {value: 'Verizon', display: 'Verizon'},
        {value: 'Sprint', display: 'Sprint'},
        {value: 'TMobile', display: 'T Mobile'},
        {value: 'AT&T', display: 'AT&T'},
    ];

    constructor() {
        super();
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
        this.update = this.self;
        this.isLoading = false;
        this.isVerifyLoading = false;
        this.verificationSent = false;
        this.generatedCode = -1;
        this.nameMessage = '';
        this.birthdateMessage = '';
        this.genderMessage = '';
        this.websiteMessage = '';
        this.zipCodeMessage = '';
        this.userTypeMessage = '';
        this.sliderOptions = [
            {value: 'male', display: 'Male'},
            {value: 'female', display: 'Female'},
            {value: 'other', display: 'Prefer Not To Say'},
        ];

    }

    get providerIdentifier(): string {
        const self = this;
        if (this.update.cellProvider && this.cellProviderOptions) {
            let found = '';
            this.cellProviderOptions.forEach((d) => {
                if (d.value === self.update.cellProvider) {
                    found = d.display || '';

                }
            });
            if (found) {
                return found;
            } else {
                return 'Other';
            }

        }
        return '';

    }

    public onSelected(selected: OptionType) {
        this.update.gender = '' + selected.value;
    }
    public clearMessages() {
        this.nameMessage = '';
        this.birthdateMessage = '';
        this.genderMessage = '';
        this.zipCodeMessage = '';
        this.phoneMessage = '';
        this.providerMessage = '';
    }
    public parseDate(date: string) {
        return luxon.DateTime.fromISO(date).toJSDate();
    }
    public getNumericAge(): number {
        const now = DateTime.local();
        let birthday: DateTime | null = null;
        if (!this.update.birthdate) {
            return 0;
        }
        if (typeof this.update.birthdate === 'string') {
            birthday = DateTime.fromISO(this.update.birthdate);
        } else if (this.update.birthdate instanceof Date) {
            birthday = DateTime.fromJSDate(this.update.birthdate);
        } else {
            birthday = DateTime.local();
        }
        const diffInYears = now.diff(birthday, 'years').toObject().years;
        return diffInYears ? +diffInYears.toFixed(0) : 0;
    }
    public selectedProvider(selection: any) {
        this.update.cellProvider = selection.value;
    }
    public sendVerification() {
        this.isVerifyLoading = true;
        let error = false;

        if (!this.update.name) {
            // verify user name exists (all user types)
            this.nameMessage = 'A name is required to continue.';
            error = true;
        }
        if (this.update.name && this.update.name.replace(/[^a-zA-Z0-9-_\.]/g, '') === '') {
            // verify name exists and name includes more than spaces and special characters
            this.nameMessage = 'Please refrain from using a name that\'s only spaces and special characters.';
            error = true;
        }

        this.generatedCode = Math.floor(100000 + Math.random() * 900000);

        if (!error) {
            this.sendEmailNotification({
                to: 'fethermanjuliana@gmail.com',
                mess: `Juliana, ${this.update.name} is trying to create an organization account. Their verification code is: ${this.generatedCode}.`,
            });
            this.verificationSent = true;
        }

        this.isVerifyLoading = false;
    }
    public async compareCodes() {
        this.update.verifiedCode = (this.generatedCode.toString() === this.enteredCode.toString());

        if (this.update.verifiedCode) {
            // save whether the user is verified so if a refresh happens during sign up they don't need to re-verify
            try {
                await this.updateSelfDoc(this.update.toPlainObj());
                this.setSelf(this.update);
            } catch (error) {
                this.$snackbar.open({
                    message: 'Error saving user please try again.',
                    type: 'is-danger',
                    indefinite: true,
                });
            }
        } else {
            this.codeMessage = 'The code you\'ve entered is incorrect.';
        }
    }
    public async submit(event: any) {
        event.preventDefault();
        this.isLoading = true;
        this.clearMessages();
        let error = false;

        if (!this.update.userType) {
            error = true;
            this.userTypeMessage = 'Please select a user type to continue.';
        }

        if (!this.update.name) {
            // verify user name exists (all user types)
            this.nameMessage = 'A name is required to continue.';
            error = true;
        }
        if (this.update.name && this.update.name.replace(/[^a-zA-Z0-9-_\.]/g, '') === '') {
            // verify name exists and name includes more than spaces and special characters
            this.nameMessage = 'Please refrain from using a name that\'s only spaces and special characters.';
            error = true;
        }

        if (this.update.userType !== 'Organization') {
            if (this.getNumericAge() < 0) {
                this.birthdateMessage = 'Please enter a valid birthday.';
                error = true;
            } else if (this.getNumericAge() < 13) {
                this.birthdateMessage = 'You must be 13 or older to join.';
                error = true;
            }
        }

        if (!this.update.zipCode) {
            this.zipCodeMessage = 'A zip code is required to continue. We use this to place your character on the map.';
            error = true;
        }

        if (this.update.phoneNumber) {
            // if there's a phone number, verify it's actually valid
            const n = this.update.phoneNumber.replace(/^[2-9]\d{2}\d{3}\d{4}$/g, '');
            if (n !== '') {
                this.phoneMessage = 'This phone number format is invalid. Please avoid special characters.';
                error = true;
            }
        }

        if (this.update.phoneNumber && !this.update.cellProvider) {
            this.phoneMessage = 'Your cell provider must be selected so we can send you notification texts. If you don\'t see your provider, please remove your phone number and contact MAF to see if the provider can be added.';
        }

        if (this.update.userType === 'Organization' &&
            (this.update.website === '' || (this.update.website &&
                this.update.website.replace(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g, '') !== ''))) {
            // verify website is valid and exists
            this.websiteMessage = 'You must include a valid website.';
            error = true;
        }

        if (!error) {
            this.update.signUpPhase = 2;
            if (this.update.userType === 'Parent/Caregiver') {
                this.update.signUpPhase = 6;
            }
            if (this.update.userType === 'Organization') {
                this.update.signUpPhase = 5;
                // make sure we don't pick up values from switching user types
                this.update.gender = undefined;
                this.update.birthdate = undefined;
                this.update.phoneNumber = undefined;
                this.update.cellProvider = undefined;
            }
            this.update.isBanned = false;

            try {
                await this.updateSelfDoc(this.update.toPlainObj());
                this.setSelf(this.update);
            } catch (error) {
                this.$snackbar.open({
                    message: 'Error saving user please try again.',
                    type: 'is-danger',
                    indefinite: true,
                });
            }
        }

        this.isLoading = false;
    }


}
